import { zodResolver } from '@hookform/resolvers/zod'
import { ComponentDestinationVO, TemplateArgVOByKey, TemplateVO } from '@repo/types'
import { useForm } from 'react-hook-form'
import { z } from 'zod'
import { TemplateHeaderVO } from '@repo/types/src/types/TemplateHeaderVO'

export type MessagePreviewData = {
  connectionKey: string
  flowId?: string
  message: string
  header?: TemplateHeaderVO
  footer: string
  buttons: string[]
}

export type NewChatFormValues = {
  origin?: ComponentDestinationVO
  phone: string
  template?: TemplateVO
  templateArgs?: TemplateArgVOByKey
  templateButtonsArgs?: TemplateArgVOByKey
  templateHeader?: TemplateHeaderVO
  searchOrigin?: string
  searchTemplate?: string
  name?: string
  messagePreviewData?: MessagePreviewData
}

// TODO: centralizar em schema.ts?
const destinationSchema = z.object({
  server: z.string(),
  tag: z.string().nullish(),
  infos: z.record(z.string(), z.string())
})

const originSchema = z.object({
  destinationId: z.number(),
  companyName: z.string(),
  userName: z.string(),
  destinationDescription: z.string(),
  connectionKey: z.string(),
  destination: destinationSchema
})

const templateSchema = z.object({
  value: z.string(),
  name: z.string(),
  template: z.string(),
  header: z
    .object({
      type: z.string()
    })
    .nullish(),
  footer: z.string().nullish(),
  category: z.string(),
  mostUsed: z.boolean(),
  buttonsDescriptions: z.array(z.string()),
  buttonsKeys: z.array(z.string()),
  bodyDescriptions: z.array(z.string()),
  bodyKeys: z.array(z.string())
})

const mediaFileSchema = z.object({
  id: z.number(),
  name: z.string(),
  mediaType: z.string(),
  url: z.string(),
  size: z.number().optional()
})

const templateArgSchema = z.object({
  description: z.string(),
  value: z.string().min(1),
  position: z.number()
})

const newChatFormSchema = z.object({
  origin: originSchema,
  phone: z.string().min(10, { message: 'Telefone é obrigatório' }).max(13),
  template: templateSchema,
  templateArgs: z.record(z.string(), templateArgSchema),
  templateButtonsArgs: z.record(z.string(), templateArgSchema),
  templateHeader: z
    .object({
      text: z.string().optional(),
      type: z.string().optional(),
      media: mediaFileSchema.optional()
    })
    .refine(schema => {
      return (!schema.type || (schema.type && schema.media)) ?? (schema.type && schema.text)
    })
})

export const useNewChatForm = (defaultPhone?: string) => {
  const resolver = zodResolver(newChatFormSchema)
  const form = useForm<NewChatFormValues>({
    mode: 'onSubmit',
    resolver,
    defaultValues: {
      origin: undefined,
      phone: defaultPhone ?? '',
      template: undefined,
      templateArgs: undefined,
      templateButtonsArgs: undefined,
      templateHeader: undefined,
      searchOrigin: undefined,
      searchTemplate: undefined,
      name: undefined,
      messagePreviewData: undefined
    }
  })

  return { ...form }
}
